export const CommonTownHallCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Municipi',
    path: '/sistema/municipi',
  },
];
